angular
  .module 'shared'
  .directive 'linksWithTargetBlank', ($timeout) ->
    restrict: 'A'
    link: (scope, element) ->
      $timeout ->
        element.find('a').each (i, item) ->
          item.target = '_blank'
